export function categories(state = [], action) {
    switch (action.type) {
      case 'RESET_APP':
      return [];
      case 'GET_CATEGORIES':
          let NewData = action.types
          action.types = NewData
          return action.types
      case 'ADD_CATEGORIES':
        let S_data = state.filter(m => m.id !== action.types.id)
        let item = action.types
        return S_data.concat(item)
      case 'REMOVED_CATEGORIES':
        let alldata = state.filter(m => m.id !== action.types.id)
        return alldata 
      default:
        return state;
    }
  }